import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { teamApi, teamToken, apiErr } from "./teamApi";

const Ctx = createContext(null);

export function TeamAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    if (!teamToken.get()) { setUser(null); return; }
    try {
      const { data } = await teamApi.get("/me/profile");
      setUser(data);
    } catch {
      teamToken.clear();
      setUser(null);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await teamApi.post("/auth/login", { email, password });
      if (data.user.role !== "employee") { setError("This is the staff app. Managers, please use the admin console."); return false; }
      teamToken.set(data.token);
      await refresh();
      return true;
    } catch (e) { setError(apiErr(e)); return false; }
  };

  const logout = () => { teamToken.clear(); setUser(null); };

  return <Ctx.Provider value={{ user, login, logout, error, refresh }}>{children}</Ctx.Provider>;
}

export function useTeamAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useTeamAuth must be inside TeamAuthProvider");
  return ctx;
}
